"use client";

import type { User } from "@firebase/auth";
import { createContext, useContext } from "react";
import { UserDocument } from "~/src/type/firebase/firestore";

/**
 * コンテキスト-認証構成データ
 */
export type UserAuthState = User | null | undefined;
export type UserAuthInfo = UserDocument | undefined;

export const USER_AUTH_NOT = null;
export const USER_AUTH_INIT = undefined;

export type AuthConstruction = {
  user: UserAuthState;
  info: UserAuthInfo;
};

/**
 * コンテキスト-認証構成データ設定関数
 */
export type AuthSetConstruction = {
  setUser: React.Dispatch<React.SetStateAction<UserAuthState>>;
  setInfo: React.Dispatch<React.SetStateAction<UserAuthInfo>>;
};

/**
 * デフォルト-グラフ構成データ
 */
export const DEFAULT_AUTH_DATA: AuthConstruction = {
  user: undefined,
  info: undefined,
};
const DEFAULT_AUTH_SET_FUNC: AuthSetConstruction = {
  setUser: () => undefined,
  setInfo: () => undefined,
};

/**
 * create
 */
export const AuthContext = createContext<AuthConstruction>(DEFAULT_AUTH_DATA);
export const AuthSetContext = createContext<AuthSetConstruction>(DEFAULT_AUTH_SET_FUNC);

/**
 * use
 */
export const useAuthContext = () => useContext(AuthContext);
export const useAuthSetContext = () => useContext(AuthSetContext);
